export function calculateChanceToWin(ticketsInCart: number, numberOfTicketsInPool: number) {
  if (!ticketsInCart) return 0;
  if (numberOfTicketsInPool === 0) {
    return 1;
  }
  return ticketsInCart / (numberOfTicketsInPool + ticketsInCart);
}
